<template>
    <div class="md:bg-pencil bg-right-top bg-no-repeat">
        <p class="no-print mt-0 font-helvetica leading-5 text-lg text-co-dark-grey">Click the letter to build your name, print your design and colour it in.</p>

        <div class="no-print max-w-5xl mx-auto flex flex-wrap justify-center my-10">

            <img v-for="n in 26"
                :key="n"
                :src="`/assets/img/letters/co-crew-letters-${n}.svg`" :alt="`Letter ${n}`"
                class="w-16 h-16 lg:w-auto lg:h-auto self-center py-2 lg:py-0 px-4 mb-4 cursor-pointer"
                @click="getSvgHtml">
        </div>

        <div class="name-builder lg:mb-4 px-4 md:p-6 motion-safe:animate-appear border border-co-blue rounded-xl no-print-border">
            <div class="py-8 flex flex-wrap justify-center items-center" ref="letters">
                <div v-for="(letter, index) in letters" :key="index">
                    <div v-if="letter.svg" v-html="letter.svg"></div>

                    <div v-if="letter.space" class="letter-space"></div>

                    <div v-if="letter.line" class="w-screen mb-2 md:mb-4"></div>
                </div>
            </div>

            <div class="no-print flex flex-wrap -mx-1 md:-mx-2 mt-10">
                <div class="w-1/2 lg:flex-1 px-1 md:px-2 mb-4 lg:mb-0">
                    <button class="btn text-xs md:text-3xl w-full" @click="createSpace">Add space</button>
                </div>
                <div class="w-1/2 lg:flex-1 px-1 md:px-2 mb-4 lg:mb-0">
                    <button class="btn text-xs md:text-3xl w-full" @click="createNewLine">Return</button>
                </div>
                <div class="w-1/2 lg:flex-1 px-1 md:px-2 mb-4 lg:mb-0">
                    <button class="btn text-xs md:text-3xl w-full" @click="deleteLetter">Delete</button>
                </div>
                <div class="w-1/2 lg:flex-1 px-1 md:px-2 mb-4 lg:mb-0">
                    <button class="btn text-xs md:text-3xl w-full bg-co-blue text-white" @click="generatePng(); track('Download Crew Name', 'Download', 'Click');">Download</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import download from 'downloadjs'
import * as htmlToImage from 'html-to-image'

export default {
    data() {
        return {
            imageSrc: false,
            letters: []
        }
    },

    methods: {
        /**
         * Get the image src of letter image on click and use axios to get svg data from file and append to letters array
         * so it can be shown on the screen when someone is building their name.
         */
        getSvgHtml(event) {
            this.imageSrc = event.target.src

            axios.get(this.imageSrc)
            .then(response => {
                this.letters.push({
                    svg: response.data
                });
            })
        },

        /**
         * Generate and download a png of the html of the letters that have been entered.
         * I've added some styles to the print media query for browsers that don't support this like IE.
         */
        generatePng() {
            htmlToImage.toPng(this.$refs.letters)
            .then((dataUrl) => {
                download(dataUrl, 'my-co-crew-name.png')
            }).catch((e) => {});
        },

        /**
         * Creates a space between letters using boolean set in letters array which corresponds to html tag in template.
         */
        createSpace() {
            this.letters.push({
                space: true
            });
        },

        /**
         * Creates artificial line break using div with a large width set.
         */
        createNewLine() {
            this.letters.push({
                line: true
            });
        },

        /**
         * Deletes the last row from the letters array which mimics a backspace press.
         */
        deleteLetter() {
            this.letters.pop()
        },

        /**
         * Google Analytics Event fire.
         */
        track(title, type, action = 'Download') {
            if (typeof ga === 'function') {
                ga('send', 'event', 'Co Crew Name', action, `${title} ${type}`)
            }
        }
    }
}
</script>

<style lang="scss">
    .name-builder {
        svg {
            width: 30px;
            height: 30px;
            margin: 0 -3px;

            @screen md {
                width: auto;
                height: auto;
                margin: 0;
            }
        }

        .letter-space {
            width: 30px;

            @screen md {
                width: 50px;
            }
        }
    }
</style>
